"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_CERTIFICATE_SETTINGS = exports.GET_CERTIFICATE_FOR_ADMIN_EDIT = exports.CERTIFICATE_FRAGMENT = void 0;
const client_1 = require("@apollo/client");
const map_1 = require("../../../../../Maps/__queries__/map");
exports.CERTIFICATE_FRAGMENT = (0, client_1.gql) `
  fragment CertificateEditFragment on Certificate {
    id
    formYear
    breakawayWalls
    documentUpload {
      id
    }
    certificateUpload {
      id
      formExpirationYear
    }
    account {
      id
      ...AccountMapFragment
    }
    property {
      id
      city
      zipcode
      state
      streetAddress
      latitude
      longitude
      parcel {
        address
        id
        lot
        block
        parcelId
        legalDescription
      }
    }
  }

  ${map_1.ACCOUNT_MAP_FRAGMENT}
`;
exports.GET_CERTIFICATE_FOR_ADMIN_EDIT = (0, client_1.gql) `
  query getCertificateForAdminEdit($id: ID!) {
    certificate(id: $id) {
      ...CertificateEditFragment
    }
  }

  ${exports.CERTIFICATE_FRAGMENT}
`;
exports.UPDATE_CERTIFICATE_SETTINGS = (0, client_1.gql) `
  mutation UpdateCertificateSettings($data: CertificateSettingsUpdateInput!) {
    updateCertificateSettings(data: $data) {
      ...CertificateEditFragment
    }
  }

  ${exports.CERTIFICATE_FRAGMENT}
`;
//# sourceMappingURL=data:application/json;base64,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